module.exports = __webpack_public_path__ + "img/SOFTEAM_logo.5c4af4c1.png";